<template>
  <a-modal
    title="复制链接"
    :visible="visible"
    :width="560"
    :footer="null"
    destroy-on-close
    @cancel="onClose"
  >
    <a-spin :spinning="linkLoading">
      <a-form-model
        :model="form"
        :label-col="{ span: 6 }"
        :wrapper-col="{ span: 16 }"
        class="copy-link-form"
      >
        <a-form-model-item label="营销文案">
          <a-textarea
            v-model="form.marketingCopy"
            :rows="10"
            placeholder="自动生成营销文案"
            allow-clear
          />
          <a-button
            class="ai-generate-btn"
            block
            :loading="aiGenerating"
            @click="onAiGenerate"
          >
            换一换 蜗友AI生成
          </a-button>
        </a-form-model-item>

        <a-form-model-item label="小程序APPID">
          <a-input v-model="form.appId" placeholder="默认值" read-only />
        </a-form-model-item>
        <a-form-model-item label="小程序原始路径">
          <a-input v-model="form.miniPath" placeholder="默认值" read-only />
        </a-form-model-item>
        <a-form-model-item label="微信链接">
          <a-input v-model="form.wechatLink" placeholder="默认值" read-only />
        </a-form-model-item>
        <a-form-model-item label="H5链接">
          <a-input v-model="form.h5Link" placeholder="默认值" read-only />
        </a-form-model-item>
      </a-form-model>
    </a-spin>
  </a-modal>
</template>

<script>
import RouterSwitchHelper from '@/utils/helper/RouterSwitchHelper'

// 小程序商城 web-view 容器（营销活动走 mallContainer）
const MINI_PAGE_PATH = '/pages/index/webView/mallContainer'
// 对应 new-h5：/marketing/activity
const H5_ACTIVITY_PATH = '/marketing/activity'

export default {
  name: 'ActivityCopyLinkModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    activity: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      linkLoading: false,
      aiGenerating: false,
      form: {
        marketingCopy: '',
        appId: '',
        miniPath: '',
        wechatLink: '',
        h5Link: ''
      }
    }
  },
  watch: {
    visible (val) {
      if (val) this.initForm()
    }
  },
  methods: {
    getActivityCode () {
      return (this.activity && this.activity.activityCode) || ''
    },
    getMerchantId () {
      return this.$store.getters.userInfo && this.$store.getters.userInfo.merchantId
    },
    resetForm () {
      this.form = {
        marketingCopy: '',
        appId: '',
        miniPath: '',
        wechatLink: '',
        h5Link: ''
      }
    },
    // new-h5：优先 newh5Url（platformConfig / appConfig），未配置时回退 h5Url
    getNewH5Domain () {
      const platformConfig = this.$store.getters.platformConfig || {}
      const appConfig = this.$store.getters.appConfig || {}
      return (platformConfig.newh5Url || appConfig.newh5Url || platformConfig.h5Url || '').replace(/\/+$/, '')
    },
    /** mallContainer 启动参数：activeShareOtherPath 传完整 newH5 URL + p */
    buildMiniShareParams (activityCode) {
      const merchantId = this.getMerchantId()
      const domainUrl = this.getNewH5Domain()
      if (!activityCode || !merchantId || !domainUrl) return null
      const character = 1
      const activeShareOtherPath = RouterSwitchHelper.getTargetUrl(domainUrl + H5_ACTIVITY_PATH, {
        activityCode
      })
      return {
        activeShareOtherPath: encodeURIComponent(activeShareOtherPath),
        p: `${character}_${merchantId}_${merchantId}`
      }
    },
    /** 展示/复制用的小程序完整路径 */
    buildMiniPath (activityCode) {
      const params = this.buildMiniShareParams(activityCode)
      if (!params) return ''
      return RouterSwitchHelper.getTargetUrl(MINI_PAGE_PATH, params)
    },
    // p = character_operatorId_merchantId（主站 operatorId 与 merchantId 相同）
    buildH5Link (activityCode) {
      const domainUrl = this.getNewH5Domain()
      if (!domainUrl || !activityCode) return ''
      const merchantId = this.getMerchantId()
      if (!merchantId) return ''
      const character = 1
      return RouterSwitchHelper.getTargetUrl(domainUrl + H5_ACTIVITY_PATH, {
        activityCode,
        p: `${character}_${merchantId}_${merchantId}`
      })
    },
    initForm () {
      this.resetForm()
      const activityCode = this.getActivityCode()
      this.form.miniPath = this.buildMiniPath(activityCode)
      this.form.marketingCopy = (this.activity && this.activity.activityTitle) || ''
      this.form.h5Link = this.buildH5Link(activityCode)
      if (activityCode) {
        this.loadWxUrlLink()
      }
    },
    /**
     * POST /marketingActivity/getWxUrlLink
     * 入参：pagePath、pageQuery（对齐 mallContainer 的 activeShareOtherPath 入参）
     * BaseService resolve 内层 data → { urlLink, appId, pagePath }
     */
    loadWxUrlLink () {
      const activityCode = this.getActivityCode()
      const params = this.buildMiniShareParams(activityCode)
      if (!params) {
        this.$message.error('缺少店铺ID或活动编码，无法生成微信链接')
        return
      }
      this.linkLoading = true
      this.form.wechatLink = ''
      this.form.miniPath = this.buildMiniPath(activityCode)
      const pageQuery = Object.keys(params)
        .map(key => `${key}=${params[key]}`)
        .join('&')
      this.getHttpServices()
        .getNewServeService()
        .post('/marketingActivity/getWxUrlLink', {
          pagePath: MINI_PAGE_PATH,
          pageQuery
        })
        .then(res => {
          this.form.appId = (res && res.appId) || ''
          this.form.wechatLink = (res && res.urlLink) || ''
          // 暂时不覆盖本地拼的小程序原始路径
          // if (res && res.pagePath) {
          //   this.form.miniPath = res.pagePath
          // }
        })
        .catch(err => {
          this.$message.error((err && err.msg) || '获取微信链接失败')
        })
        .finally(() => {
          this.linkLoading = false
        })
    },
    onClose () {
      this.$emit('update:visible', false)
      this.$emit('close')
    },
    /**
     * POST /marketingActivity/aiGenerateCopy
     * 入参：prompt
     * BaseService resolve 内层 data → { activityText }
     */
    onAiGenerate () {
      if (this.aiGenerating) return
      const prompt = (
        (this.form.marketingCopy || '').trim() ||
        (this.activity && this.activity.activityTitle) ||
        ''
      ).trim()
      if (!prompt) {
        this.$message.warning('请先输入营销文案或活动标题')
        return
      }
      this.aiGenerating = true
      this.getHttpServices()
        .getNewServeService()
        .post('/marketingActivity/aiGenerateCopy', { prompt })
        .then(res => {
          const activityText = (res && res.activityText) || ''
          if (!activityText) {
            this.$message.warning('未返回生成文案')
            return
          }
          this.form.marketingCopy = activityText
          this.$message.success('生成成功')
        })
        .catch(err => {
          this.$message.error((err && err.msg) || '生成失败，请重试')
        })
        .finally(() => {
          this.aiGenerating = false
        })
    }
  }
}
</script>

<style scoped lang="less">
.copy-link-form {
  /deep/ .ant-form-item {
    margin-bottom: 16px;
  }

  /deep/ .ant-input[readonly] {
    color: rgba(0, 0, 0, 0.65);
    background-color: #f5f5f5;
    cursor: default;
  }

  .ai-generate-btn {
    margin-top: 8px;
    color: #1890ff;
    border-color: #1890ff;
  }
}
</style>
